import Button from "atoms/buttons/button";
import { ButtonStyles } from "atoms/constants/button-styles";
import Paragraph from "atoms/typography/paragraph";
import UserBookmarkShareFilterOption from "models/enumerations/filtering/user-bookmarks/user-bookmark-share-filter-option";
import { UserBookmarkCountBy } from "models/enumerations/sorting/user-bookmarks/user-bookmark-count-by";
import React from "react";
import { useHistory, useLocation } from "react-router";
import { ShareFilterValueToNameMap } from "utilities/bookmark-utils";
import useFilterBookmarks from "utilities/hooks/domain/my-link/use-filter-bookmarks";
import useSearchBookmarks from "utilities/hooks/domain/my-link/use-search-bookmarks";
import { t } from "utilities/localization-utils";
import { RouteUtils } from "utilities/route-utils";

interface MyBookmarksClearAllProps {
    countBy?: UserBookmarkCountBy;
}

const MyBookmarksClearAll = ({ countBy }: MyBookmarksClearAllProps) => {
    const { pathname, search } = useLocation();
    const { replace } = useHistory();

    const { searchText, searchTextKey } = useSearchBookmarks(countBy ?? "");
    const { shareFilter, shareFilterKey } = useFilterBookmarks(countBy ?? "");

    const shareFilterDefault = UserBookmarkShareFilterOption.All;

    const handleClearAll = () => {
        const params = new URLSearchParams(search);
        [searchTextKey, shareFilterKey].forEach((key) => params.delete(key));
        replace(RouteUtils.appendQueryParams(pathname, params));
    };

    const showFilterText = shareFilter !== shareFilterDefault;
    const showSearchText = !!searchText;

    // TODO: TRANSLATE
    const text =
        showFilterText && showSearchText ? (
            <span>
                Filter by{" "}
                <strong>{t(ShareFilterValueToNameMap[shareFilter])}</strong> and
                contains <strong>{searchText}</strong>
            </span>
        ) : showFilterText ? (
            <span>
                Filter by{" "}
                <strong>{t(ShareFilterValueToNameMap[shareFilter])}</strong>
            </span>
        ) : showSearchText ? (
            <span>
                Contains <strong>{searchText}</strong>
            </span>
        ) : (
            ""
        );

    return (
        <>
            {text && (
                <Paragraph>
                    <span>{text}. </span>
                    <Button
                        style={ButtonStyles.AnchorBlue}
                        onClick={handleClearAll}>
                        {t("clearAll")}
                    </Button>
                </Paragraph>
            )}
        </>
    );
};

export default MyBookmarksClearAll;
